export default __webpack_public_path__ + "static/media/icon_audio_play.599c2da6.svg";